import React from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  TextField,
  Divider,
} from "@mui/material";

const RemarkModal = ({
  remarkModalOpen,
  handleCloseRemarkModal,
  remarkValue,
  setRemarkValue,
  handleSaveRemark,
  ticketIdd,
  centerObjId,
  technicianMessage,
  name,
}) => {
  return (
    <Modal
      open={remarkModalOpen}
      onClose={handleCloseRemarkModal}
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <Box
        className="bg-white shadow-2xl rounded-2xl w-[400px] p-6 transition-all duration-300"
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 3,
        }}
      >
        {/* Title */}
        <Typography
          variant="h6"
          className="text-center font-semibold text-gray-800"
        >
          Add Remark
        </Typography>

        {/* Text Area */}
        <TextField
          value={remarkValue}
          onChange={(e) => setRemarkValue(e.target.value)}
          label="Write your remark"
          multiline
          minRows={3}
          variant="outlined"
          fullWidth
          className="rounded-lg"
        />

        {/* Save Button */}
        <Button
          onClick={() => handleSaveRemark(ticketIdd, centerObjId)}
          variant="contained"
          color="primary"
          className="rounded-xl py-2 font-medium shadow-md hover:shadow-lg transition"
        >
          Save Remark
        </Button>

        {/* Divider */}
        <Divider />

        {/* Technician Message */}
        <Box className="bg-gray-50 rounded-lg p-3 border border-gray-200">
          <Typography variant="body2" className="text-gray-700">
            {technicianMessage ? technicianMessage : "No remarks available"}{" "}
            <span className="font-semibold text-red-600 ml-2">{name}</span>
          </Typography>
        </Box>
      </Box>
    </Modal>
  );
};

export default RemarkModal;
